
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Mumbaipunecabbooking() {



    const cardData =
    {
        keyword: 'Mumbai Pune Cab Booking',
        heading: 'Mauli Cabs: Mumbai Pune Cab Booking',
        headingDescription: 'Mauli Cabs offers seamless and reliable Mumbai Pune cab booking services, making your intercity travel easy, quick, and stress-free. Whether you are planning a one-way trip, round trip, or a same-day return, we provide a fleet of well-maintained sedans, SUVs, and premium vehicles to suit your travel preferences. With user-friendly online booking, professional drivers, transparent pricing, and no hidden charges, Mauli Cabs ensures a comfortable and punctual journey every time you book a cab from Mumbai to Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Taxi Fare Return",
      "description": "Book a taxi for your round-trip journey from Mumbai to Pune. With our competitive return taxi fare, enjoy a comfortable ride both ways. Our service offers a range of vehicle options, from economy sedans to premium SUVs, ensuring you get the best value and convenience for your return trip."
    },
    {
      "name": "Mumbai to Wanwadi Cab Service",
      "description": "Travel with ease from Mumbai to Wanwadi with our reliable and punctual cab service. We provide a range of vehicles to suit your travel needs, from budget-friendly sedans to more spacious options like SUVs and MPVs. Our experienced drivers ensure a smooth, comfortable journey every time."
    },
    {
      "name": "Mumbai to Mundwa Cab Service",
      "description": "Book a comfortable and hassle-free cab from Mumbai to Mundwa, Pune. Whether you're traveling for business or leisure, we ensure a timely and safe ride with professional drivers. Choose from various vehicle options based on your budget and comfort preferences."
    },
    {
      "name": "Mumbai to Wadgaon Sheri Cab Service",
      "description": "Get reliable and affordable cab service from Mumbai to Wadgaon Sheri, Pune. Our fleet of well-maintained vehicles ensures a comfortable ride with timely pickups. We cater to both solo travelers and group trips, providing the perfect vehicle for your journey."
    },
    {
      "name": "Mumbai to Nigdi Cab Service",
      "description": "Book a cab from Mumbai to Nigdi, Pune, and enjoy a smooth and reliable ride. Whether you're heading to a business meeting or a family visit, our drivers ensure a safe and punctual trip. We offer flexible booking options with a range of vehicles to suit your preferences."
    },
    {
      "name": "Mumbai to Swargate Cab",
      "description": "Enjoy a comfortable ride from Mumbai to Swargate with our cab service. Whether it's for personal or business travel, our vehicles come with professional drivers, and we offer the best fares without compromising on quality or service. Timely pickups and a smooth ride guaranteed."
    },
    {
      "name": "Mumbai to Pune Station Cab",
      "description": "Catch your train on time with our dependable taxi service from Mumbai to Pune Station. We offer reliable, comfortable rides with punctual drivers who know the fastest routes to ensure you make it to your train without any delays. Book online for a hassle-free experience."
    },
    {
      "name": "Mumbai to Shivaji Nagar Cab",
      "description": "Travel comfortably from Mumbai to Shivaji Nagar with our reliable cab service. Our fleet of vehicles ensures that you get to your destination safely and on time, whether you're traveling for business or leisure. Choose from different vehicle categories based on your preferences."
    },
    {
      "name": "Mumbai Pune Taxi Booking",
      "description": "Book your Mumbai to Pune taxi ride online with ease. Our platform offers transparent pricing, multiple payment options, and a fleet of vehicles to suit your travel needs. Enjoy a comfortable, safe, and timely journey with professional drivers and top-rated vehicles."
    },
    {
      "name": "Mumbai Pune Taxi Booking",
      "description": "Reserve your taxi for the Mumbai to Pune route with our easy online booking system. With a range of vehicles including sedans, SUVs, and MPVs, we provide reliable service for both business and leisure travelers. We guarantee comfort, safety, and on-time pickups."
    },
    {
      "name": "Mumbai to Pune Cab",
      "description": "Book a cab from Mumbai to Pune with our easy online booking system. Whether it's a one-way or round-trip journey, we offer affordable, safe, and comfortable rides. Choose from a variety of vehicles, and enjoy the convenience of a professional driver who knows the best routes."
    },
    {
      "name": "Pune to Mumbai Cabs",
      "description": "Travel from Pune to Mumbai in comfort with our reliable cab service. Whether you're heading for business or leisure, we provide timely pickups and a smooth journey. Our fleet includes a variety of vehicles to suit your needs and budget."
    },
    {
      "name": "Mumbai to Pune Cab Service",
      "description": "Enjoy a seamless and comfortable ride from Mumbai to Pune with our trusted cab service. We offer a wide selection of vehicles, from economy sedans to luxury SUVs, ensuring you have a stress-free journey. Book your ride online for hassle-free service and affordable pricing."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Our Pune to Mumbai cab service ensures you travel comfortably and safely. We offer a range of vehicles for every budget and need, from sedans to SUVs. With experienced drivers and guaranteed punctuality, we make your journey between these two cities as smooth as possible."
    },
    {
      "name": "Pune Mumbai Taxi Service",
      "description": "Choose our Pune Mumbai taxi service for a comfortable and reliable ride. With easy online booking, our service offers vehicles ranging from budget-friendly options to premium cars. Enjoy timely service, experienced drivers, and a smooth ride every time."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Book your Pune to Mumbai cab with ease through our online booking platform. We offer a range of vehicle options to cater to your travel preferences, ensuring comfort and affordability. Our drivers ensure a safe and timely ride with every booking."
    },
    {
      "name": "Cab Service Mumbai to Pune",
      "description": "Book a cab service from Mumbai to Pune with our easy-to-use platform. Whether you're looking for an economy ride or a luxury vehicle, we offer reliable and affordable service. Experience a comfortable journey with our well-maintained vehicles and professional drivers."
    },
    {
      "name": "Mumbai to Pune Taxi Charges",
      "description": "Get clear and transparent pricing for your Mumbai to Pune taxi ride. Our service ensures no hidden charges, with a variety of vehicles to choose from based on your budget and preferences. Check competitive fare details and book your ride in just a few clicks."
    },
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "Book a spacious and comfortable Innova cab for your journey from Mumbai to Pune. Ideal for families and small groups, the Toyota Innova offers ample space and comfort. Our service ensures a smooth ride, timely pickups, and a hassle-free experience at competitive pricing."
    },
    {
      "name": "Mumbai to Pune Innova Crysta on Rent",
      "description": "Rent a Toyota Innova Crysta for your trip from Mumbai to Pune. Known for its superior comfort and spacious interiors, the Innova Crysta is perfect for group travel. Our rental service offers great flexibility, with well-maintained vehicles and professional drivers."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Taxi Fare Return", "Mumbai to Wanwadi Cab Service"],
    ["Mumbai to Mundwa Cab Service", "Mumbai to Wadgaon Sheri Cab Service"],
    ["Mumbai to Nigdi Cab Service", "Mumbai to Swargate Cab"],
    ["Mumbai to Pune Station Cab", "Mumbai to Shivaji Nagar Cab"],
    ["Mumbai Pune Taxi Booking", "Mumbai Pune Taxi Booking"],
    ["Mumbai to Pune Cab", "Pune to Mumbai Cabs"],
    ["Mumbai to Pune Cab Service", "Pune to Mumbai Cab Service"],
    ["Pune Mumbai Taxi Service", "Pune to Mumbai Cab Booking"],
    ["Cab Service Mumbai to Pune", "Mumbai to Pune Taxi Charges"],
    ["Mumbai to Pune Innova Cab", "Mumbai to Pune Innova Crysta on Rent"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Seamless Mumbai to Pune Cab Booking",
        "WhyChoosedescription": "Mauli Cabs makes your Mumbai to Pune cab booking fast and easy through our user-friendly website and mobile app. Book your ride in just a few clicks with instant confirmation."
    },
    {
        "WhyChooseheading": "Clean, Comfortable & Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes sedans, SUVs, and premium cars, all air-conditioned and regularly sanitized. Enjoy a safe and relaxing trip every time you travel from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are skilled and know the best routes from Mumbai to Pune, ensuring timely pickups, smooth driving, and a safe, efficient journey."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer transparent and competitive rates for Mumbai Pune cab bookings. What you see is what you pay—no surprise fees or last-minute additions."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Mauli Cabs is available 24/7, so you can book your cab at any hour. Our dedicated support team is always ready to assist you with any queries or changes to your booking."
    },
    {
        "WhyChooseheading": "Real-Time Ride Tracking and Notifications",
        "WhyChoosedescription": "Stay informed throughout your journey with live ride tracking, driver updates, and estimated arrival notifications—right from booking to drop-off."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Rides",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are sanitized before every trip, and our drivers are background-verified, ensuring a safe and hygienic travel experience."
    },
    {
        "WhyChooseheading": "Flexible and Convenient Payment Options",
        "WhyChoosedescription": "Pay your way—choose from UPI, debit/credit cards, mobile wallets, or cash. Our cab booking platform supports secure and flexible payments tailored to your convenience."
    }
]





























    }

    const faqData = [
        {
            question: 'How can I book a cab from Mumbai to Pune with Mauli Cabs?',
            answer: 'Booking a cab from Mumbai to Pune with Mauli Cabs is simple. Visit our website or download our app, enter your pickup location as "Mumbai" and drop location as "Pune", select your preferred cab type, and confirm the booking. For any help, our support team is available 24/7.',
        },
        {
            question: 'What cab options are available for Mumbai to Pune bookings?',
            answer: 'Mauli Cabs offers a range of cab options including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Whether you’re traveling solo or with a group, there’s a vehicle to match your comfort and budget.',
        },
        {
            question: 'Is the fare for Mumbai to Pune cab booking fixed?',
            answer: 'Yes, we offer fixed and transparent pricing. Your fare includes tolls, fuel, driver charges, and taxes. No hidden charges—what you see before confirming the booking is what you pay.',
        },
        {
            question: 'How long does the journey from Mumbai to Pune take?',
            answer: 'Typically, the drive from Mumbai to Pune takes between 3.5 to 5 hours, depending on traffic and weather conditions. For a smoother trip, consider starting early or avoiding peak travel times.',
        },
        {
            question: 'Can I book a cab for a one-way or round trip between Mumbai and Pune?',
            answer: 'Yes, we offer both one-way and round-trip bookings. Round-trip options are ideal for same-day or next-day returns and can be more cost-effective.',
        },
        {
            question: 'Is advance cab booking available from Mumbai to Pune?',
            answer: 'Absolutely. You can book your cab days or even weeks in advance to ensure availability, especially during holidays or weekends.',
        },
        {
            question: 'Do you offer 24/7 Mumbai to Pune cab services?',
            answer: 'Yes, Mauli Cabs operates 24/7. Whether you need an early morning ride or a late-night pickup, we’ve got you covered.',
        },
    ];
    
    const testimonials = [
        {
            name: "Dr. Anjali Patil",
            position: "Dentist",
            text: "I had to book a last-minute cab from Mumbai to Pune and Mauli Cabs made it super easy. The car was clean, and the ride was comfortable. I’m really impressed with their service.",
            image: "/img/testimonial/testimonial-thumb-1-43.png",
        },
        {
            name: "Mr. Rohit Shinde",
            position: "Logistics Manager",
            text: "Booked a cab from Mumbai to Pune for a business trip. The booking process was smooth and the driver was extremely professional. Will definitely use Mauli Cabs again.",
            image: "/img/testimonial/testimonial-thumb-1-44.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Pune Cab Booking",
        "description": "Mauli Cabs provides easy and affordable Mumbai to Pune cab booking services. Choose from a variety of vehicles including Innova Crysta, Ertiga, and sedan cabs for a comfortable journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5465"
        }
      };
      
    

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Mumbai Pune Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Mumbai to Pune cab with Mauli Cabs. Choose from Innova Crysta, Ertiga, and sedan options for a comfortable and affordable ride. Taxi services available for both one-way and return trips."
        />
        <meta
          name="keywords"
          content="mumbai to pune taxi fare return, mumbai to wanwadi cab service, mumbai to mundwa cab service, mumbai to wadgaon sheri cab service, mumbai to nigdi cab service, mumbai to swargate cab, mumbai to pune station cab, mumbai to shivaji nagar cab, mumbai pune taxi booking, mumbai pune taxi booking, mumbai to pune cab, pune to mumbai cabs, mumbai to pune cab service, pune to mumbai cab service, pune mumbai taxi service, pune to mumbai cab booking, cab service mumbai to pune, mumbai to pune taxi charges, mumbai to pune innova cab, mumbai to pune innova crysta on rent"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/144.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaipunecabbooking;